export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/floatingButton.d93cb4ce.svg","height":108,"width":72,"blurWidth":0,"blurHeight":0};